import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import CountAdj01Actions, { CountAdj01Types } from '../Stores/CountAdj01/Actions';

const getAppStore = state => state.app;

export function* countAdj01FetchCountAdj01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(CountAdj01Actions.countAdj01FetchCountAdj01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `countAdj/indexProcess/COUNT_ADJ_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        CountAdj01Actions.countAdj01FetchCountAdj01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdj01Actions.countAdj01FetchCountAdj01Loading(false));
  }
}

export function* countAdj01CreateCountAdj01({ hdrIds }) {
  try {
    yield put(CountAdj01Actions.countAdj01CreateCountAdj01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      siteFlowId: app.curSiteFlowId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `countAdj/createProcess/COUNT_ADJ_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(CountAdj01Actions.countAdj01CreateCountAdj01Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(CountAdj01Actions.countAdj01CreateCountAdj01Loading(false));
  }
}

export function* countAdj01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/cycleCountDetail/update/${hdrId}`));
}

export function* countAdj01NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/cycleCountDetail/create/${app.curSiteFlowId}`));
}

export const saga = [
  takeLatest(CountAdj01Types.COUNT_ADJ01_GO_TO_DOCUMENT, countAdj01GoToDocument),
  takeLatest(CountAdj01Types.COUNT_ADJ01_FETCH_COUNT_ADJ01, countAdj01FetchCountAdj01),
  takeLatest(CountAdj01Types.COUNT_ADJ01_CREATE_COUNT_ADJ01, countAdj01CreateCountAdj01),
  takeLatest(CountAdj01Types.COUNT_ADJ01_NEW_DOCUMENT, countAdj01NewDocument)
];
